import { PayoutsSimulator } from '@/containers/simulator';

export default function SimulatorRoute() {
  return <PayoutsSimulator />;
}
